import { DataLayerItem } from '../types';

import { removeGaPrefix } from './remove-ga-prefix';

export const pushDataToGtmFromDataset = (
  target: HTMLElement,
  additionalDataForGA: DataLayerItem,
) => {
  const gaData: DataLayerItem = { ...additionalDataForGA };

  for (const key in target.dataset) {
    if (!key.startsWith('ga')) {
      continue;
    }

    const keyWithGaPrefix = key as `ga${string}`;
    const value = target.dataset[keyWithGaPrefix];

    if (!value) {
      continue;
    }

    gaData[removeGaPrefix(keyWithGaPrefix)] = value;
  }

  window.dataLayer.push(gaData);
};
